import { useRef } from "react";
import { useWMS2040_R01Store } from "src/containers/mes/WMS/WMS2040_R01/Store_WMS2040_R01";
import { Content_WMS2040_R01 } from "./Content_WMS2040_R01";
import { SearchSection_WMS2040_R01 } from "./SearchSection_WMS2040_R01";
import { Table_WMS2040_R01 } from "./Table_WMS2040_R01";
import { DetailTable_WMS2040_R01 } from "./DetailTable_WMS2040_R01";
import { Message } from "src/components/common/form/Message";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import { AgGridReact } from "ag-grid-react";
import { WMS2040_R01HeaderDto, WMS2040_R01DetailDto } from "./Dto_WMS2040_R01";

export const Container_WMS2040_R01 = () => {
	const {
		allCount,
		initData,
	} = useWMS2040_R01Store();

	const { setMessage } = useUiuxStore();
	const { yesNoList } = useCommonCodeStore();

	// 스플릿(리사이저) 관련
	const RESIZER = {
		code: 'WMS2040_R01',
		type: 'width',
		storageKey: 'WMS2040_R01-split-width',
		min: 10,
		max: 90,
		default: 50,
	} as const;

	const gridRef = useRef<AgGridReact<WMS2040_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<WMS2040_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const detailRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const { splitValue, handleMouseDown } = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef: detailRef,
	});

	// Content에서 핸들러 함수들 가져오기
	const {
		fetchData,
		initContainerData,
		handleDetailExcelClick,
		handleTableRowClick,
	} = Content_WMS2040_R01({ 
		gridRef,
		detailGridRef,
		setMessage,
	});

	
	return (
		<div className="content-container">	  
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => {}}
				onDeleteClick={() => {}}
				onSaveClick={() => {}}
				onExcelClick={handleDetailExcelClick}
				onInitClick={initContainerData}
			/>
			
			{/* 검색/필터 영역 */}
			<SearchSection_WMS2040_R01 />
			
			<div className="flex-1 flex gap-[4px] p-[12px]" ref={containerRef}>
				<div className="h-full" style={{ width: `${splitValue}%` }}>
					<Table_WMS2040_R01 onRowClick={handleTableRowClick} gridRef={gridRef} />
				</div> 
				
				{/* 리사이저 */}
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e) => handleMouseDown('LR', e.nativeEvent)}
				/>
				
				<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={detailRef}>
					<DetailTable_WMS2040_R01 
						gridRef={detailGridRef} 
					/>
				</div>
			</div>
			
			<Message />
		</div>
	);
};

export default Container_WMS2040_R01; 